import { useSaveBar } from './useSaveBar';
import { useCallback } from 'react';

export function useUnsavedGuard(hasUnsavedChanges: boolean) {
  const { shopifySaveBar } = useSaveBar();

  const withUnsavedGuard = useCallback(
    (callback: () => void) => () => {
      if (hasUnsavedChanges) {
        shopifySaveBar?.leaveConfirmation?.();
        return;
      }
      callback();
    },
    [hasUnsavedChanges, shopifySaveBar],
  );

  return {
    withUnsavedGuard,
  };
}
